import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="vendor--beacon"
// Lazy-loads Beacon script only when user clicks Contact button
export default class extends Controller {

  /** identify example
   {
      name: this.emailValue,
      email: this.emailValue,
    }
   */
  static values = {
    init: {
      type: String,
      default: 'b286493c-658d-4b93-a834-f953ef82b2ff',
    },
    open: {
      type: Boolean,
      default: false
    },
    identify: {
      type: Object,
      default: {},
    },
    loaded: {
      type: Boolean,
      default: false
    }
  }

  initialize () {
    // Script loading deferred to first user interaction
  }

  connect() {
    // Beacon initialization deferred to first user interaction
  }

  loadBeacon() {
    if (this.loadedValue) return Promise.resolve()

    return new Promise((resolve) => {
      // Initialize Beacon queue
      if (!window.Beacon) {
        window.Beacon = function (t, n, a) {
          window.Beacon.readyQueue.push({ method: t, options: n, data: a })
        }
        window.Beacon.readyQueue = []
      }

      // Load the script
      const script = document.createElement("script")
      script.type = "text/javascript"
      script.async = true
      script.src = "https://beacon-v2.helpscout.net"
      script.onload = () => {
        this.loadedValue = true
        window.Beacon('init', this.initValue)
        window.Beacon('identify', this.identifyValue)
        window.Beacon('on', 'open', () => this.openValue = true)
        window.Beacon('on', 'close', () => this.openValue = false)
        resolve()
      }
      document.head.appendChild(script)
    })
  }

  openValueChanged() {
    if (!this.loadedValue) return
    const style = this.openValue ? 'icon' : 'manual'
    window.Beacon('config', {
      display: {
        style: style,
      }})
  }

  disconnect() {
    //window.Beacon('destroy')
  }

  async toggle(e) {
    e.preventDefault()
    await this.loadBeacon()
    window.Beacon('toggle')
  }

}
